import React from 'react';
import { Camera } from 'lucide-react';
import { useRevealOnScroll } from '../../hooks/useGsap';
import Marquee from '../ui/Marquee';
import SmartImage from '../ui/SmartImage';

const row1 = [
  { src: '/media/img/lei.jpg', label: 'Evento da AgroTech em parceria com a LEI' },
  { src: '/media/img/mantiqueira.png', label: 'Visita ao escritório da Mantiqueira' },
  { src: '/media/img/palestra.jpg', label: 'Palestra técnica em evento de agro' },
  { src: '/media/img/visita-atvos.jpg', label: 'Visita ao escritório da Atvos' },
];

const row2 = [
  { src: '/media/img/agrominas.jpg', label: 'Visita ao escritório da Agrominas' },
  { src: '/media/img/prêmio-marketing.jpeg', label: 'Premiação clube com melhor marketing 2025' },
  { src: '/media/img/rei-das-batidas.jpg', label: 'Confraternização da liga' },
  { src: '/media/img/entrega-projeto.jpg', label: 'Entrega do projeto Effatha' },
];

const GalleryCard = ({ src, label }) => (
  <div className="group relative w-[300px] md:w-[380px] shrink-0">
    <SmartImage
      src={src}
      label={label}
      className="rounded-2xl aspect-[16/11] border border-white/[0.07] group-hover:border-primary-400/50 transition-colors duration-300"
      imgClassName="group-hover:scale-110 transition-transform duration-700 ease-out"
    />
    <div className="pointer-events-none absolute inset-0 rounded-2xl bg-gradient-to-t from-night-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    <span className="pointer-events-none absolute bottom-3 left-4 text-xs font-medium text-mist-100 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
      {label}
    </span>
  </div>
);

const Gallery = () => {
  const ref = useRevealOnScroll();

  return (
    <section id="gallery" ref={ref} className="relative py-28 bg-night-950 overflow-hidden">
      <div className="container-custom mb-14">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <span className="eyebrow reveal">
              <Camera size={13} />
              A liga em campo
            </span>
            <h2 className="section-title reveal mt-4">
              Do código à <span className="text-gradient">colheita</span>
            </h2>
          </div>
          <p className="reveal text-mist-400 max-w-sm leading-relaxed">
            Eventos, imersões, entregas e bastidores — a rotina de quem constrói
            tecnologia para o agro.
          </p>
        </div>
      </div>

      <div className="space-y-5">
        <Marquee speed={60} className="py-1">
          {row1.map((item) => (
            <GalleryCard key={item.src} {...item} />
          ))}
        </Marquee>
        <Marquee speed={70} reverse className="py-1">
          {row2.map((item) => (
            <GalleryCard key={item.src} {...item} />
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default Gallery;
